import { makeADT } from '@morphic-ts/adt/lib';
import { array, difference, intersection } from 'fp-ts/Array';
import { eqString } from 'fp-ts/Eq';
import { identity, tuple } from 'fp-ts/function';
import { fromFoldable as RfromFoldable, mapWithIndex as RmapWithIndex } from 'fp-ts/Record';
import { assignCallable, wrapFun } from './utils';
const recordFromArray = RfromFoldable({ concat: identity }, array);
const keepKeys = (a, toKeep) => recordFromArray(intersection(eqString)(Object.keys(a), toKeep).map((k) => tuple(k, a[k])));
const excludeKeys = (a, toExclude) => recordFromArray(difference(eqString)(Object.keys(a), toExclude).map((k) => tuple(k, a[k])));
/**
 *  @since 0.0.1
 */
export function makeTagged(summ) {
    return tag => o => {
        // Trust the outer signature - type lookup via unknown URI cannot have any semantic here
        // const summoned:  M<EParam<Types>, AParam<Types>, ProgURI, InterpURI> = summ<EParam<Types>, AParam<Types>>((F: any) =>
        const summoned = summ(((F) => F.taggedUnion(tag, RmapWithIndex((_k, v) => v(F))(o))) // FIXME: resolve any
        ); // Trust
        const adt = makeADT(tag)(o);
        const preTagged = makeTagged(summ)(tag);
        const selectMorph = (selectedKeys) => preTagged(keepKeys(o, selectedKeys));
        const excludeMorph = (selectedKeys) => preTagged(excludeKeys(o, selectedKeys));
        // FIXME: as any
        const res = assignCallable(wrapFun(summoned), Object.assign(Object.assign(Object.assign({}, summoned), adt), { selectMorph,
            excludeMorph }));
        return res;
    };
}
